var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 12,
    viewBox: "0 0 20 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3798 0.462095L19.492 5.57429C19.7271 5.80948 19.7271 6.19079 19.492 6.42598L14.3798 11.5382C14.1539 11.7641 13.8475 11.891 13.5281 11.891L0.602231 11.891C0.269627 11.891 -8.42937e-08 11.6213 0 11.2887L2.63418e-07 0.711545C2.63418e-07 0.378942 0.269628 0.109314 0.602232 0.109314L13.5281 0.109316C13.8475 0.109316 14.1539 0.236214 14.3798 0.462095ZM12.3411 7.24977C13.0313 7.93992 14.1502 7.93992 14.8404 7.24977C15.5305 6.55961 15.5305 5.44066 14.8404 4.7505C14.1502 4.06035 13.0313 4.06035 12.3411 4.7505C11.651 5.44065 11.651 6.55961 12.3411 7.24977Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.6ead4ea0.svg";
export { ForwardRef as ReactComponent };